import React, { useEffect, useState } from 'react'
import { Button, Form, Row } from 'react-bootstrap'
import { api } from '../../../shared/ApiProvider'

const grades = [
  { value: '', label: 'None Selected' },
  { value: 'PreK', label: 'PreK' },
  { value: 'K', label: 'K' },
  { value: '01', label: '1' },
  { value: '02', label: '2' },
  { value: '03', label: '3' },
  { value: '04', label: '4' },
  { value: '05', label: '5' },
  { value: '06', label: '6' },
  { value: '07', label: '7' },
  { value: '08', label: '8' },
  { value: '09', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
]

export default function QueryBuilder({ setSearchResults, setLoading, setHasSearched }) {
  const [districts, setDistricts] = useState([])
  const [queryParams, setQueryParams] = useState(JSON.parse(window.localStorage.getItem('queryParams')) || {})
  const [searchWarning, setSearchWarning] = useState(false)
  const [schools, setSchools] = useState([])
  const [searchError, setSearchError] = useState('')

  const fetchData = async (url, setter, valueString, labelString) => {
    try {
      let response = await api.get(url)
      let optionData = response.data
      if (optionData.length > 0) {
        optionData = optionData.map(l => ({
          value: l[valueString],
          label: `${l[labelString]} (${l[valueString]})`,
        }))
      }
      setter(optionData)
    } catch (error) {
      setSearchError('Failed to load data. Please try again.')
    }
  }
  useEffect(() => {
    fetchData('/public/schools', setSchools, 'OrgID', 'Name')
    fetchData('/public/districts', setDistricts, 'OrgID', 'Name')
  }, [])

  useEffect(() => {
    if (queryParams.districtId) {
      fetchData(`/schools/district/${queryParams.districtId}`, setSchools, 'OrgID', 'Name')
    } else {
      fetchData('/public/schools', setSchools, 'OrgID', 'Name')
    }
  }, [queryParams.districtId])

  const findIfShouldSearch = paramObj => {
    return Object.values(paramObj).some(val => val != null && String(val).trim() !== '')
  }

  const handleChange = e => {
    let id = e.target.id
    let value = e.target.value
    setQueryParams(prevState => ({
      ...prevState,
      [id]: value,
    }))
  }

  const makeQueryString = (url, paramObj) => {
    const query = Object.entries(paramObj)
      .filter(([, value]) => value != null && String(value).trim() !== '')
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')
    return query ? `${url}?${query}` : url
  }

  const searchForStudent = async url => {
    setLoading(true)
    setSearchError('')
    try {
      const result = await api.get(url)
      setSearchResults(result.data)
      window.localStorage.setItem('searchResults', JSON.stringify(result.data))
      setHasSearched(true)
    } catch {
      setSearchError('Search failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const clickSearchButton = e => {
    e.preventDefault()
    if (findIfShouldSearch(queryParams)) {
      setSearchWarning(false)
      setSearchError('')
      localStorage.setItem('queryParams', JSON.stringify(queryParams))
      searchForStudent(makeQueryString('/student/search', queryParams))
    } else {
      setSearchWarning(true)
    }
  }

  const clearSearch = () => {
    localStorage.removeItem('queryParams')
    localStorage.removeItem('searchResults')
    setQueryParams({})
    setLoading(false)
    setSearchResults([])
    setSearchError('')
    setHasSearched(false)
  }

  return (
    <div className="d-flex flex-column">
      <Form className="col-12" onSubmit={clickSearchButton}>
        <Row>
          <Form.Group className="mb-3 col-12 col-md-6" controlId="firstName">
            <Form.Label>First Name</Form.Label>
            <Form.Control onChange={handleChange} value={queryParams.firstName || ''} type="text" placeholder="First Name" />
          </Form.Group>
          <Form.Group className="mb-3 col-12 col-md-6" controlId="lastName">
            <Form.Label>Last Name</Form.Label>
            <Form.Control onChange={handleChange} value={queryParams.lastName || ''} type="text" placeholder="Last Name" />
          </Form.Group>

          <Form.Group className="mb-3 col-12 col-md-6" controlId="districtId">
            <Form.Label>School District</Form.Label>
            <Form.Control value={queryParams.districtId || ''} onChange={handleChange} as="select" placeholder="School District">
              <option value="">Select a District</option>
              {districts.map((option, i) => (
                <option key={i} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group className="mb-3 col-12 col-md-6" controlId="schoolId">
            <Form.Label>School</Form.Label>
            <Form.Control value={queryParams.schoolId || ''} onChange={handleChange} as="select" placeholder="School">
              <option value="">Select a School</option>
              {schools.map((option, i) => (
                <option key={i} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Row>
        <Row className="d-flex justify-content-center">
          <Form.Group className="mb-3 col-12 col-md-4" controlId="permNum">
            <Form.Label>PERM Number</Form.Label>
            <Form.Control value={queryParams.permNum || ''} onChange={handleChange} type="text" inputMode="numeric" pattern="[0-9]*" placeholder="PERM Number" />
          </Form.Group>
          <Form.Group className="mb-3 col-12 col-md-4" controlId="grade">
            <Form.Label>Grade</Form.Label>
            <Form.Control value={queryParams.grade || ''} onChange={handleChange} as="select" placeholder="School District">
              {grades.map((option, i) => (
                <option key={i} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Button type="button" variant="outline-secondary" className="col-12 col-md-4 mt-3 align-self-center" onClick={clearSearch}>
            Clear
          </Button>
        </Row>
        <Row className="d-flex text-center justify-content-center">
          {searchWarning && (
            <div role="alert" className="col-4 p-2 alert alert-warning text-center">
              Please enter at least one field
            </div>
          )}
          {searchError && (
            <div role="alert" className="col-4 p-2 alert alert-danger text-center">
              {searchError}
            </div>
          )}
        </Row>
        <Row className="justify-content-center">
          <Button type="submit" className="col-3 mt-3 align-self-center">
            Search
          </Button>
        </Row>
      </Form>
    </div>
  )
}
